var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('QualityRawMeasurementTable',{attrs:{"is-detailed":true,"measurements":_vm.rawmaterial.measurements,"rawid":parseInt(_vm.rawmaterial.id),"raw-title":_vm.rawmaterial.barcode + ' ' + _vm.rawmaterial.name,"loading":_vm.loading}})}
var staticRenderFns = []

export { render, staticRenderFns }